import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import DatePicker from "react-datepicker";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { ToastContainer, toast } from "react-toastify";
import { useForm } from "react-hook-form";
import ContentLoader from "react-content-loader";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import AddProcessingService from "../../../services/Processing/createProcessing";
import Scheduler from "../../schedule";

function GenrateBills({ id, setContract_number, schedule, setSchedule, setShowScheduler, setSelectedValue, selectedValue, setBillTroughDate, billtroughdate, GenrateBilltableRef,
  showScheduler,
  setScheduleType,
  scheduleType,
  setStartDate,
  startDate,
  setStartTime,
  startTime,
  setEndDate,
  endDate,
  setEndTime,
  endTime,
  setRerunInterval,
  rerunInterval,
  setRerunUnit,
  rerunUnit,
  setSelectedMonths,
  selectedMonths,
  setSelectedDates,
  selectedDates,
  setFrequency,
  frequency,
  setSelectedWeekdays,
  selectedWeekdays,
  setIncrementParams,
  incrementParams,
  setRecalculateParams,
  recalculateParams,
  setIsLoading,
  isLoading,
  moniter,
  setMoniter
}) {
  const navigate = useNavigate();
  const [billloading, setBillLoading] = useState(true);
  const [selectedValue3, setSelectedValue3] = useState("");
  const [flag, setFlag] = useState("");
  const [flagNotification, setFlagNotification] = useState("");
  const [invoice_series, setInvoiceSeries] = useState("");
  const [successful, setSuccessful] = useState(false);
  // const [moniter, setMoniter] = useState("Billing");
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  const [disable, setDisable] = useState(false);

  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue2, setValue2] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);

  const checkBtn = useRef();
  const {
    handleSubmit,
  } = useForm();
  const form = useRef();

  let localDateTime = new Date();
  let startDateValue = localDateTime.toISOString().split('T')[0];

  const loadOptionsData = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}contracts/contractsactive/filter/?id=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };

  const handleMenuScrollToBottom = () => {
    loadOptionsData(inputvalue2, currentPage2);
  };

  // const handelInputChange = (value) => {
  //   setValue(value);
  // };
  // const handelChange = (value) => {
  //   setSelectedValue(value);
  // };

  const handelChange2 = (value1) => {
    setSelectedValue(value1);
    setContract_number(value1)
  };

  const hadelRefresh = () => {
    GenrateBilltableRef.current.onQueryChange();
    setBillTroughDate(new Date())

  };

  const handleReset = () => {
    setSelectedValue3("");
    GenrateBilltableRef.current.onQueryChange();
  };
  const [state1, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  const handelChangebilling = (value) => {
    setSelectedValue3(value);
  };

  useEffect(() => {
    setBillLoading(false);
  }, [id]);

  const invoice_number_method = async () => {
    await axios
      .get(API + `billing/invoice_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setInvoiceSeries(response.data.details);
          // handleRegister();
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update Invoice Setting",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/additionalsettings"),
              },
            ],
          });
        }
      })
   
  };

  const loadOptionsbilling = async () => {
    GenrateBilltableRef.current.onQueryChange();
  };

  // const handleRegister = () => {
  //   setShowScheduler(true)
  //   setSuccessful(false);
  //   setLoading(true);
  //   setDisable(true);
  //   form.current.validateAll();
  //   if (checkBtn.current.context._errors.length === 0) {
  //     AddProcessingService.addProcessing(
  //       selectedValue ? selectedValue.id : "",
  //       moniter,
  //       billtroughdate.toISOString().split("T")[0]
  //     ).then((response) => {
  //       if (response.data.success) {
  //         if (response.data.billing) {
  //           setFlag(flag + 1);
  //           setLoading(false);
  //         } else {
  //           setFlagNotification(flagNotification + 1);
  //           setLoading(false);
  //         }
  //         setSuccessful(true);
  //         setSelectedValue("");
  //         setBillTroughDate("");
  //         axios.post(API + 'helper/schedule-task/', {
  //           "task_type": "instant",
  //           "process_name": moniter
  //         },
  //           {
  //             headers: authHeader()
  //           }
  //         ).then((res) => {
  //           console.log('res', res)
  //         })

  //         toast.success(`${response.data.response}`, {
  //           position: "top-right",
  //           autoClose: 1000,
  //           hideProgressBar: false,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         setTimeout(() => {
  //           setDisable(false);
  //           GenrateBilltableRef.current.onQueryChange();
  //         }, 1000);
  //       } else {
  //         toast.error(`${response.data.error}`, {
  //           position: "top-right",
  //           autoClose: 1000,
  //           hideProgressBar: false,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //         setSuccessful(false);
  //         setDisable(false);
  //         setLoading(false);
  //       }
  //     })
  //     // .catch((error) => {
  //     //   toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
  //     //     position: "top-right",
  //     //     autoClose: 4000,
  //     //     hideProgressBar: false,
  //     //     pauseOnHover: true,
  //     //     draggable: true,
  //     //     progress: undefined,
  //     //     theme: "light",
  //     //   })

  //     // });
  //   }
  // };

  const handleInputChangeData = (value) => {
    setValue2(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptionsData(value, 1);
  };

  const handleschedule = () => {
    if (scheduleType === 'once') {
      // if (startDate === '') {
      //   setSchedule({
      //     task_type: 'instant',
      //     process_name: moniter
      //   })
      // } else {
      setIsLoading(true)
      const localDateTime = new Date(`${startDate}T${startTime}`)
      const taskTime = localDateTime.toISOString().split('.')[0] + 'Z';

      const value = {
        task_type: 'specific',
        task_time: taskTime,
        process_name: moniter,
        parameter1: selectedValue ? selectedValue.id : "",
        parameter2: billtroughdate.toISOString().split("T")[0],
        start_date: startDate !== '' ? startDate : startDateValue,
      }
      axios.post(API + 'helper/schedule-task/', value,
        {
          headers: authHeader()
        }
      ).then((res) => {
        if (res.data.success === 1) {
          setStartDate('')
          setEndDate('')
          setStartTime('')
          setEndTime('')
          setFrequency('')
          setIsLoading(false)
          toast.success(res.data.response)
        }
        setTimeout(() => {
          GenrateBilltableRef.current.onQueryChange();
        }, 1000);
      }).catch((e) => {
        setIsLoading(false)
      })
      // }
    } else {
      const formattedStartDate = `${startDate} ${startTime}`;
      const formattedEndDate = `${endDate} ${endTime}`;
      const localDateTime = new Date(`${startDate}T${startTime}`);
      const taskTime = localDateTime.toISOString().split('.')[0] + 'Z';
      // const startMonth = new Date(startDate).getMonth(); 
      // const startMonthName = months[startMonth];

      // const finalMonths = selectedMonths.length === 0 ? [startMonthName] : selectedMonths;
      if (rerunInterval === '') {
        const value = {
          task_type: 'custom',
          task_time: taskTime,
          interval_type: rerunUnit,
          interval_value: rerunInterval,
          start_date: formattedStartDate,
          end_date: formattedEndDate,
          // month: finalMonths,
          month: selectedMonths,
          days_of_month: selectedDates,
          days_of_week: selectedWeekdays,
          process_name: moniter,
          parameter1: selectedValue ? selectedValue.id : "",
          parameter2: startDate !== '' ? startDate : startDateValue,
        }
        axios.post(API + 'helper/schedule-task/', value,
          {
            headers: authHeader()
          }
        ).then((res) => {
          if (res.data.success === 1) {
            setStartDate('')
            setEndDate('')
            setFrequency('')
            setStartTime('')
            setEndTime('')
            setIsLoading(false)
            setTimeout(() => {
              setShowScheduler(false)
              GenrateBilltableRef.current.onQueryChange();
            }, 1000);
          }
        }).catch((e) => {
          setIsLoading(false)
        })
      } else {
        const value = {
          task_type: 'periodic',
          task_time: taskTime,
          interval_type: rerunUnit,
          interval_value: rerunInterval,
          start_date: formattedStartDate,
          process_name: moniter,
          parameter1: selectedValue ? selectedValue.id : "",
          parameter2: billtroughdate.toISOString().split("T")[0] ,
        }
        axios.post(API + 'helper/schedule-task/', value,
          {
            headers: authHeader()
          }
        ).then((res) => {
          if (res.data.success === 1) {
            toast.success(res.data.response)
            setStartDate('')
            setEndDate('')
            setFrequency('')
            setStartTime('')
            setEndTime('')
            setIsLoading(false)
          }
          setTimeout(() => {
            setShowScheduler(false)
            GenrateBilltableRef.current.onQueryChange();
          }, 1000);
        }).catch((e) => {
          setIsLoading(false)
        })
      }
    }
    setShowScheduler(false)
  }

  return (
    <>
      <div className="page-wrapper">
        <ToastContainer />
        <div className="content container-fluid">
          {billloading === false ? (
            <div className="row" id="payschedule" style={{ marginTop: "10px" }}>
              <Form
                role="form text-left"
                onSubmit={handleSubmit(invoice_number_method)}
                ref={form}
                action="."
                method="POST"
              >
                {
                  <>
                    <div className="row">
                      <div className="col-xl-4 processingindex">
                        {/* <div className="form-group row">
                          <label className="col-lg-5 col-form-label">
                            {t("Contract Number")}
                          </label>
                          <div className="col-lg-9">
                            <Select
                              value={selectedValue}
                              filterOption={false}
                              options={options2}
                              isClearable
                              onInputChange={handleInputChangeData}
                              getOptionLabel={(options) => options.contract_number}
                              getOptionValue={(options) => options.contract_number}
                              isLoading={isLoading2}
                              placeholder={t("Search for Contract(%for All)")}
                              onMenuScrollToBottom={handleMenuScrollToBottom}
                              onChange={handelChange2}
                            />

                            <input
                              type="hidden"
                              id="contract_status"
                              value=""
                            />
                          </div>
                        </div> */}
                      </div>
                      <div className="col-xl-3">
                        <div className="form-group row">
                          {/* <label className="col-lg-5 col-form-label">
                            {t("Bill Through Date")}
                          </label> */}
                          <div className="col-lg-9">
                            {/* <DatePicker
                              className="form-control datepick"
                              selected={billtroughdate}
                              onChange={(e) => setBillTroughDate(e)}
                              placeholderText={"mm/dd/yyyy"}
                              showYearDropdown // year show and scrolldown alos
                              scrollableYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                            /> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-xl-4">
                        <div className="form-group row">
                          <div
                            className="col-lg-12 text-right"
                            style={{ marginTop: "30px" }}
                          >
                            {/* <button
                              disabled={disable}
                              className="requestBilling btn btn-primary ms-auto mb-0"
                              style={{ marginRight: '10px' }}
                              onClick={handleSchedule}
                            >
                              {t("Run Now")}
                            </button> */}

                            <button
                              type="button"
                              className="refreshRequest btn bg-gradient-secondary ms-auto mb-0"
                              onClick={hadelRefresh}
                            >
                              {t("Refresh")}
                            </button>
                            &nbsp;&nbsp;
                            {

                              permissionss && permissionsArray.includes('add_processing') === true ?
                                <button
                                  type="button"
                                  disabled={disable}
                                  className="requestBilling btn btn-primary ms-auto mb-0"
                                  onClick={() => setShowScheduler(true)}
                                >
                                  {
                                    // t("Apply")
                                    // t("Run Now")
                                    t("Schedule")
                                  }
                                </button> : ""
                            }
                            &nbsp;&nbsp;
                          </div>
                          {showScheduler &&
                            <Scheduler
                              showScheduler={showScheduler}
                              setShowScheduler={setShowScheduler}
                              handleschedule={handleschedule}
                              onSave={() => {
                                setIsLoading(true)
                                form.current.validateAll();
                                if (checkBtn.current.context._errors.length === 0) {
                                  AddProcessingService.addProcessing(
                                    selectedValue ? selectedValue.id : "",
                                    moniter,
                                    // startDate !== '' ? startDate : startDateValue
                                    billtroughdate.toISOString().split("T")[0]
                                  ).then((response) => {
                                    if (response.data.success) {
                                      if (response.data.billing) {
                                        setFlag(flag + 1);
                                        // setLoading(false);
                                      } else {
                                        setFlagNotification(flagNotification + 1);
                                        // setLoading(false);
                                      }
                                      setSuccessful(true);
                                      setSelectedValue("");
                                      // setBillTroughDate("");
                                      axios.post(API + 'helper/schedule-task/', {
                                        "task_type": "instant",
                                        "process_name": moniter
                                      },
                                        {
                                          headers: authHeader()
                                        }
                                      ).then((res) => {
                                        if (res.data.success === 1) {
                                          setIsLoading(false)
                                        }
                                      }).catch((error) => {
                                        setIsLoading(false)
                                      })

                                      toast.success(`${response.data.response}`, {
                                        position: "top-right",
                                        autoClose: 1000,
                                        hideProgressBar: false,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                      });
                                      setTimeout(() => {
                                        setDisable(false);
                                        setIsLoading(false)
                                        setShowScheduler(false)
                                        GenrateBilltableRef.current.onQueryChange();
                                      }, 1000);
                                    } else {
                                      toast.error(`${response.data.error}`, {
                                        position: "top-right",
                                        autoClose: 1000,
                                        hideProgressBar: false,
                                        pauseOnHover: true,
                                        draggable: true,
                                        progress: undefined,
                                        theme: "light",
                                      });
                                      setSuccessful(false);
                                      setDisable(false);
                                      // setLoading(false);
                                      setIsLoading(false)
                                    }
                                  })
                                 
                                }
                              }}
                              options2={options2}
                              setIsLoading2={setIsLoading2}
                              setValue2={setValue2}
                              inputvalue2={inputvalue2}
                              setCurrentPage2={setCurrentPage2}
                              currentPage2={currentPage2}
                              isLoading2={isLoading2}
                              setOptions2={setOptions2}
                              setScheduleType={setScheduleType}
                              scheduleType={scheduleType}
                              setStartDate={setStartDate}
                              startDate={startDate}
                              setStartTime={setStartTime}
                              startTime={startTime}
                              setEndDate={setEndDate}
                              endDate={endDate}
                              setEndTime={setEndTime}
                              endTime={endTime}
                              setRerunInterval={setRerunInterval}
                              rerunInterval={rerunInterval}
                              setRerunUnit={setRerunUnit}
                              rerunUnit={rerunUnit}
                              setSelectedMonths={setSelectedMonths}
                              selectedMonths={selectedMonths}
                              setSelectedDates={setSelectedDates}
                              selectedDates={selectedDates}
                              setFrequency={setFrequency}
                              frequency={frequency}
                              setSelectedWeekdays={setSelectedWeekdays}
                              selectedWeekdays={selectedWeekdays}
                              setIncrementParams={setIncrementParams}
                              incrementParams={incrementParams}
                              setRecalculateParams={setRecalculateParams}
                              recalculateParams={recalculateParams}
                              setSchedule={setSchedule}
                              moniter={moniter}
                              setMoniter={setMoniter}
                              setSelectedValue={setSelectedValue}
                              selectedValue={selectedValue}
                              billtroughdate={billtroughdate}
                              GenrateBilltableRef={GenrateBilltableRef}
                              setIsLoading={setIsLoading}
                              isLoading={isLoading}
                              setBillTroughDate={setBillTroughDate}
                              setContract_number={setContract_number}
                            />
                          }
                        </div>
                      </div>
                      <div className="col-xl-1 form-group row pt-4">
                        <span
                          className="text-right"
                          onClick={() => setState({ isPaneOpen: true })}
                          style={{
                            color: "#b4b7c5",
                            paddingRight: "1px",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={
                              process.env.PUBLIC_URL +
                              "/static/images/ic-filter.svg"
                            }
                            alt=""
                          />
                        </span>
                      </div>
                    </div>
                  </>
                }
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
              <SlidingPane
                className="some-custom-class"
                overlayClassName="some-custom-overlay-class"
                isOpen={state1.isPaneOpen}
                title="Filter By"
                subtitle=""
                onRequestClose={() => {
                  setState({ isPaneOpen: false });
                }}
              >
                <div className="col-md-12">
                  <div className="">
                    <div className="">
                      <div className="col-lg-12 mb-3">
                        <label className="col-lg-5 col-form-label">
                          {t("Request Date")}
                        </label>
                        <DatePicker
                          className="form-control datepick"
                          selected={selectedValue3}
                          onChange={(e) => handelChangebilling(e)}
                          placeholderText={"mm/dd/yyyy"}
                          showYearDropdown 
                          scrollableYearDropdown
                          showMonthDropdown
                          dropdownMode="select"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <button
                      type="button"
                      className="clearAll btn bg-gradient-secondary ms-auto mb-0 "
                      onClick={handleReset}
                    >
                      {t("Reset")}
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      onClick={loadOptionsbilling}
                      className="partyFilter add btn btn-primary ms-auto mb-0"
                    >
                      {t("Apply")}
                    </button>
                    &nbsp;&nbsp;
                  </div>
                </div>
              </SlidingPane>
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="table-responsive">
                      <MaterialTable
                        tableRef={GenrateBilltableRef}
                        style={{
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          zIndex: 0
                        }}
                        columns={[
                          {
                            title: `${t("Request ID")}`,
                            field: "id",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Request ID")}{" "}
                                </div>
                                <div>{rowData.id}</div>
                              </>
                            ),
                            defaultSort: "desc",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },

                          {
                            title: `${t("Process Name")}`,
                            field: "process_name",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Process Name")}{" "}
                                </div>
                                <div>{rowData.process_name}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Contract Number")}`,
                            field: "parameter1",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Contract Number")}{" "}
                                </div>
                                <div>{rowData.parameter1 ? rowData.parameter1 : "None"}</div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Bill Through Date")}`,
                            field: "parameter2",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Bill Through Date")}
                                </div>
                                <div>
                                  {Helper.DateNormal(rowData.parameter2)}
                                </div>
                              </>
                            ),
                            // export: false,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Request Date")}`,
                            field: "request_date",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Request Date")}
                                </div>
                                <div>
                                  {Helper.DateNormal(rowData.request_date)}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },

                          {
                            title: `${t("Status")}`,
                            field: "status",
                            render: (rowData) => (
                              <>
                                <div className="d-xl-none tc d-md-none d-lg-none">
                                  {t("Status")}
                                </div>{" "}
                                <div
                                  className={
                                    rowData.status === "success"
                                      ? "badge bg-gradient-success text-xxs"
                                      : "badge badge-sm bg-gradient-secondary"
                                  }
                                >
                                  {rowData.status}
                                </div>
                              </>
                            ),
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        // data={items}
                        data={(query) =>
                          new Promise((resolve, reject) => {
                            const { orderBy, orderDirection } = query;

                            let url =
                              API + "processing/manageProcessing/Billing/?";
                            url += "per_page=" + query.pageSize;
                            url += "&page=" + (query.page + 1);
                            url += "&search=" + query.search;
                            url += `&request_date=${selectedValue3
                              ? Helper.DatePicker(selectedValue3)
                              : ""
                              }`;
                            if (orderBy) {
                              url += `&orderBy=${orderBy.field}`;
                              url += `&orderDirection=${orderDirection}`;
                            }
                            fetch(url, { headers: authHeader() })
                              .then((response) => response.json())
                              .then((result) => {
                                resolve({
                                  data:
                                    query.orderBy && query.orderDirection
                                      ? _.orderBy(
                                        result.data,
                                        [query.orderBy.field],
                                        [query.orderDirection]
                                      )
                                      : result.data,
                                  page: result.page - 1,
                                  totalCount: result.total,
                                });
                              });
                          })
                        }
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
                            color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 10, 
                          emptyRowsWhenPaging: false, 
                          pageSizeOptions: [10, 30, 35, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -1,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <ContentLoader
              viewBox="0 0 1000 550"
              backgroundColor="rgba(0,0,0,0.06)"
              foregroundColor="rgba(0,0,0,0.12)"
            >
              <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
              <circle cx="879" cy="123" r="11" />
              <circle cx="914" cy="123" r="11" />
              <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
              <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
              <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
              <circle cx="880" cy="184" r="11" />
              <circle cx="915" cy="184" r="11" />
              <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
              <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
              <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
              <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="242" r="11" />
              <circle cx="916" cy="242" r="11" />
              <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="303" r="11" />
              <circle cx="917" cy="303" r="11" />
              <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
              <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
              <circle cx="881" cy="363" r="11" />
              <circle cx="916" cy="363" r="11" />
              <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
              <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
              <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
              <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
              <circle cx="882" cy="424" r="11" />
              <circle cx="917" cy="424" r="11" />
              <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
              <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
              <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
              <circle cx="882" cy="484" r="11" />
              <circle cx="917" cy="484" r="11" />
              <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
              <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
              <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
              <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
              <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
              <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
              <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
              <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
              <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
              <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
            </ContentLoader>
          )}
        </div>
      </div>
    </>
  );
}

export default GenrateBills;
